import { Navigate, Outlet } from 'react-router-dom'

function PrivateRoute({ children, ...rest }) {
	//  console.log("hello")
	return localStorage.getItem('token') && localStorage.getItem('sansthaId') ? (
		<Navigate to="/dashboard" />
	) : (
		// <Navigate to="/"/>
		<Outlet />
	)
}

export default PrivateRoute
